$(document).ready(function () {


    var dtToday = new Date();
    
    var month = dtToday.getMonth () + 1;
    
    var day = dtToday.getDate() +1; 
    
    var year = dtToday.getFullYear();
    
    if (month < 10) 
      month = '0' + month.toString();
    
    if(day < 10) 
      day = '0' + day.toString();
    
    var maxDate1 = year +'-'+ month +'-'+ day;
  
      
      $('#dateControl').attr('min', maxDate1);
  
    
}) 


$(document).ready(function () {

$('#dateControl').datepicker({ 
dateFormat: "dd-mm-yy", 
changeMonth: true, 
changeYear: true, 
maxDate: "15D",
minDate: "1D"

})

});